export const GET_EMPLOYEES_ASSETS_REPORT = 'GET_EMPLOYEES_ASSETS_REPORT';
export const RESET_EMPLOYEES_ASSETS_REPORT = 'RESET_EMPLOYEES_ASSETS_REPORT';
export const SET_EMPLOYEES_ASSETS_REPORT_PAGINATION = 'SET_EMPLOYEES_ASSETS_REPORT_PAGINATION';
export const SET_EMPLOYEES_ASSETS_REPORT_FILTERS = 'SET_EMPLOYEES_ASSETS_REPORT_FILTERS';
export const GENERATE_EMPLOYEE_ASSETS_PDF = 'GENERATE_EMPLOYEE_ASSETS_PDF';



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/constants/employees_assets_report_constants.js